<template>
	<div>
		<FlexiblePaymentCondition
			v-if="paymentCondition === PaymentCondition.FLEXIBLE"
			:displayTitle="props.displayTitle"
			:prestId="props.prestId"
			:isPVFlex="props.isPVFlex"
			:isDisplayPlaceholders="props.isDisplayPlaceholders"
			:content="store.state.content"
			:cancellationDate="props.cancellationDate"
			:startDate="startDate" />

		<FixedPaymentCondition
			v-else
			:displayTitle="props.displayTitle"
			:prestId="props.prestId"
			:isDisplayPlaceholders="props.isDisplayPlaceholders"
			:content="store.state.content" />
	</div>
</template>

<script setup lang="ts">
import { defineProps, computed, ComputedRef } from "vue"

// Store
//import store from "@/vue/planning/store/store"

// Enums
import { PaymentCondition } from "@/enums/paymentCondition"

// Components
import FlexiblePaymentCondition from "./FlexiblePaymentCondition.vue"
import FixedPaymentCondition from "./FixedPaymentCondition.vue"


import { useStore } from "vuex"
const store = useStore();

// Props
interface Props {
	paymentCondition: number
	displayTitle: boolean
	cancellationDate: string
	isPVFlex?: boolean
	prestId?: string
	isDisplayPlaceholders?: boolean
}

const props = defineProps<Props>()

// Computed
const startDate: ComputedRef<string> = computed(() => {
	return store.state.dates.BeginDate || ""
})
</script>
